import React from 'react'
import styles from "./BtnBack.module.css";
import {Link, withRouter} from 'react-router-dom'

const BtnBack = ({
    title = 'Главная',
    titleBack = 'Назад',
    history
}) => {

    const checkLink = (history
        ?.location
            ?.pathname
                ?.split('/'))
        ?.find(el => el == 'all') === 'all';
    return (
        <div>
            <Link
                to={`${checkLink
                ? '/'
                : '/dashboard'}`}
                className={styles.button}>{title}</Link>
            <div onClick={history.goBack} className={styles.buttonBackStep}>{titleBack}</div>
        </div>
    )
}

export default withRouter(BtnBack)